import { render } from "./Study_Profile.vue?vue&type=template&id=759080f2&scoped=true"
import script from "./Study_Profile.js?vue&type=script&lang=js"
export * from "./Study_Profile.js?vue&type=script&lang=js"

import "./Study_Profile.vue?vue&type=style&index=0&id=759080f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759080f2"]])

export default __exports__